// This file is used to provide the field names for NGL forms
export const getOapFieldNames = (): Record<
	string,
	string | Record<string, string>
> => {
	return {
		// Funeral Home
		funeralHomeName: 'funeralHomeName',
		funeralHomeCityState: 'funeralHomeCityState',

		// Agent
		agentName: 'agentName',
		agentProducerNumber: 'agentProducerNumber',
	}
}
